type Status = 'shadow' | 'enabled' | 'paused' | string;

const statusStyles: Record<string, string> = {
  shadow: 'bg-gray-100 text-gray-600',
  enabled: 'bg-green-100 text-green-700',
  paused: 'bg-yellow-100 text-yellow-700'
};

export function StatusBadge({ status }: { status: Status }) {
  const cls = statusStyles[status] ?? 'bg-gray-100 text-gray-600';
  return (
    <span className={`inline-block px-2 py-0.5 rounded-full text-xs font-medium ${cls}`}>
      {status}
    </span>
  );
}
